import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { ScrollManager } from "@/components/ScrollManager";
import { Footer } from "@/components/Footer";
import { StickyMobileBar } from "@/components/StickyMobileBar";
import Home from "@/pages/Home";
import ServicesHub from "@/pages/ServicesHub";
import ServicePage from "@/pages/ServicePage";
import DmePage from "@/pages/DmePage";
import FreeEstimate from "@/pages/FreeEstimate";
import WhatWeAccept from "@/pages/WhatWeAccept";
import About from "@/pages/About";
import FaqPage from "@/pages/FaqPage";
import ContactPage from "@/pages/ContactPage";
import CityPage from "@/pages/CityPage";
import OurWork from "@/pages/OurWork";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      delete window.lenis;
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="min-h-screen bg-ink text-slate-300 antialiased">
        <ScrollManager />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesHub />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/dme-tuning-dallas" element={<DmePage />} />
            <Route path="/services/dme-tuning" element={<Navigate to="/dme-tuning-dallas" replace />} />
            <Route path="/free-estimate" element={<FreeEstimate />} />
            <Route path="/what-we-accept" element={<WhatWeAccept />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/service-areas/:slug" element={<CityPage />} />
            <Route path="/our-work" element={<OurWork />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <StickyMobileBar />
      </div>
    </BrowserRouter>
  );
}

export default App;
